// @flow
import BreadcrumbItem from 'esm-web-pro/components/layout/BreadcrumbItem';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Box, Text } from 'grommet';
import { type Breadcrumb } from 'esm-web-pro/redux/breadcrumb/reducer';
import getBreadcrumbs from 'esm-web-pro/redux/breadcrumb/selectors';
import { getIsLandingTab } from 'esm-web-pro/redux/landingTab';
import { normalizeToLocation, resolveToLocation } from 'react-router-dom/modules/utils/locationUtils';

const mapStateToProps = (state) => ({ breadcrumbs: getBreadcrumbs(state), isLandingTab: getIsLandingTab(state) });

type Props = {
    breadcrumbs: Array<Breadcrumb>,
    isLandingTab: boolean,
    history: { push: (location: string) => void },
    location: Object,
}

@withRouter
@connect(mapStateToProps)
class Breadcrumbs extends React.Component<Props> {
    static defaultProps = {
        breadcrumbs: [],
    };

    handleClick = (link) => {
        const { history, isLandingTab, location } = this.props;

        if (isLandingTab) {
            const to = link ?? '';
            const normalizedLocation = normalizeToLocation(
                resolveToLocation(to, location),
                location,
            );
            window.open(history.createHref(normalizedLocation), '_blank');
        } else {
            history.push(link);
        }
    };

    render() {
        const { breadcrumbs } = this.props;
        return (
            <Box direction="row" width="100%" overflow="hidden">
                {breadcrumbs.length ? breadcrumbs.map(
                    (b: Breadcrumb, i: number) => (
                        <React.Fragment key={b.title}>
                            <BreadcrumbItem
                                title={b.title}
                                link={b.link}
                                onClick={this.handleClick}
                            />
                            {(breadcrumbs.length !== i + 1) && (
                                <Box pad="small">
                                    <Text>
                                &gt;
                                    </Text>
                                </Box>
                            )}
                        </React.Fragment>
                    ),
                ) : null}
            </Box>
        );
    }
}

export default Breadcrumbs;
